import { render } from "./CardResumenServiciosBuscador.vue?vue&type=template&id=5c11d562"
import script from "./CardResumenServiciosBuscador.vue?vue&type=script&lang=js"
export * from "./CardResumenServiciosBuscador.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__